export enum TagSourceType {
  SYSTEM = 1,
  DATALOAD = 2,
  USER = 3,
}
